import * as React from 'react';

import { ILocalization } from 'bernie-l10n';

import { UitkHeading } from 'uitk-react-text';

export interface MitMessageHeaderProps {
  l10n: ILocalization;
  localizedMessage: string;
}

export const MitMessageHeader: React.FunctionComponent<MitMessageHeaderProps> = ({ l10n, localizedMessage }) => (
  <div className="all-b-padding-four">
    <UitkHeading level={1} size={700}>
      {l10n.formatText(localizedMessage)}
    </UitkHeading>
  </div>
);

MitMessageHeader.displayName = 'MitMessageHeader';
